import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

// PrimeNG
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { DialogModule } from 'primeng/dialog';
import { DragDropModule } from 'primeng/dragdrop';
import { GalleriaModule } from 'primeng/galleria';
// import { GMapModule } from 'primeng/gmap';
import { InputMaskModule } from 'primeng/inputmask';
import { MenuModule } from 'primeng/menu';
import { MessageService } from 'primeng/api';
import { MultiSelectModule } from 'primeng/multiselect';
import { PaginatorModule } from 'primeng/paginator';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SliderModule } from 'primeng/slider';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { CheckboxModule } from 'primeng/checkbox';

import { MuFormFieldsetComponent } from './mu-form-fieldset/mu-form-fieldset.component';
import { MuFormSectionComponent } from './mu-form-section/mu-form-section.component';
import { MuFormButtonsComponent } from './mu-form-buttons/mu-form-buttons.component';
import { MuTableComponent } from './mu-table/mu-table.component';
import { MuTableCaptionDirective } from './directives/mu-table-caption.directive';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../sharedComponents/shared.module';
import { MuTableFilterDirective } from './directives/mu-table-filter.directive';
import { MuTableCellDirective } from './directives/mu-table-cell.directive';
import { MuModalDialogLayoutComponent } from './mu-modal-dialog/mu-modal-dialog-layout.component';
import { MuMultiselectComponent } from './mu-multiselect/mu-multiselect.component';
import { MuTableOptionsComponent } from './mu-table-options/mu-table-options.component';
import { MuMapComponent } from './mu-map/mu-map.component';
import { MuSelectButtonComponent } from './mu-select-button/mu-select-button.component';
import { MuFormCurrencyComponent } from './mu-form-currency/mu-form-currency.component';
import { MuSectionTitleComponent } from './mu-section-title/mu-section-title.component';
import { MuTableNotFoundDirective } from './directives/mu-table-not-found.directive';
import { MuFilterToolbarComponent } from './mu-filter-toolbar/mu-filter-toolbar.component';
import { MuSidebarComponent } from './mu-sidebar/mu-sidebar.component';
import { MuFilterToolbarFieldDirective } from './directives/mu-filter-toolbar-field.directive';
import { MuFilterToolbarSidebarComponent } from './mu-filter-toolbar-sidebar/mu-filter-toolbar-sidebar.component';
import { MuLoadingModalDialogComponent } from './mu-loading-modal-dialog/mu-loading-modal-dialog.component';
import { MuFormPasswordComponent } from './mu-form-password/mu-form-password.component';
import { MuFormPasswordCheckerComponent } from './mu-form-password-checker/mu-form-password-checker.component';
import { MuFormDropdownComponent } from './mu-form-dropdown/mu-form-dropdown.component';
import { ValidatorModule } from '../validator/validator.module';
import { MuPopupMenuComponent } from './mu-popup-menu/mu-popup-menu.component';
import { MuAlertModalDialogComponent } from './mu-alert-modal-dialog/mu-alert-modal-dialog.component';
import { MuButtonComponent } from './mu-button/mu-button.component';
import { MuTableCellEditorDirective } from './directives/mu-table-cell-editor.directive';
import { MuAccordionTemplateDirective } from './directives/mu-accordion-template.directive';
import { MuButtonExtraComponent } from './mu-button-extra/mu-button-extra.component';
import { MuAccordionPreviewTemplateDirective } from './directives/mu-accordion-preview-template.directive';
import { MuFilterToolbarFieldLabelDirective } from './directives/mu-filter-toolbar-field-label.directive';
import { MuRadioIconComponent } from './mu-radio-icon/mu-radio-icon.component';
import { MuStepsBreadcrumbComponent } from './mu-steps-breadcrumb/mu-steps-breadcrumb.component';
import { PermissionModule } from '../permission/permission.module';
import { MuChatComponent } from './chat/chat.component';
import { MuModalEvidencesComponent } from './mu-modal-evidences/mu-modal-evidences.component';
import { MuModalRateComponent } from './mu-modal-rate/mu-modal-rate.component';
import { MuRatingComponent } from './mu-rating/mu-rating.component';
import { MuModalScheduleComponent } from './mu-modal-schedule/mu-modal-schedule.component';
import { MuModalCancelComponent } from './mu-modal-cancel/mu-modal-cancel.component';
import { MuSliderComponent } from './mu-slider/mu-slider.component';
import { MuRadioCreditCardComponent } from './mu-radio-credit-card/mu-radio-credit-card.component';
import { MuPaymentAddCardComponent } from './mu-payment-add-card/mu-payment-add-card.component';
import { MuAlertComponent } from './mu-alert/mu-alert.component';
import { MuPaymentAddPseComponent } from './mu-payment-add-pse/mu-payment-add-pse.component';
import { MuPaymentsAddWireTransferComponent } from './mu-payments-add-wire-transfer/mu-payments-add-wire-transfer.component';
import { MuFormAddressComponent } from './mu-form-address/mu-form-address.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MuAutosizeDirective } from './directives/mu-autosize.directive';
import { MuFormInputComponent } from './mu-form-input/mu-form-input.component';
import { MuFormDropdownCountryComponent } from './mu-form-dropdown-country/mu-form-dropdown-country.component';
import { MuModalFormSmsComponent } from './mu-modal-form-sms/mu-modal-form-sms.component';
import { MuAutosizeCustomDirective } from './directives/mu-autosize-custom.directive';
import { MuMapMarkerService } from '../../sharedServices/map/mu-map-marker.service';
import { MuFormCodeSmsComponent } from './mu-form-code-sms/mu-form-code-sms.component';
import { MuFormTextareaComponent } from './mu-form-textarea/mu-form-textarea.component';
import { MuNotImagenDirective } from './directives/mu-not-imagen.directive';
import { MuNotImagenCustomDirective } from './directives/mu-not-imagen-custom.directive';
import { MuFormCheckboxRoleComponent } from './mu-form-checkbox-role/mu-form-checkbox-role.component';
import { ChipModule } from 'primeng/chip';
import { MuChipComponent } from './mu-chip/mu-chip.component';
import { MuMapStaticComponent } from './mu-map-static/mu-map-static.component';
import { MuCalendarComponent } from './mu-calendar/mu-calendar.component';
import { MuAtlasComponent } from './mu-atlas/mu-atlas.component';
import { MuMapLeafletComponent } from './mu-map-leaflet/mu-map-leaflet.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    MuFormFieldsetComponent,
    MuFormSectionComponent,
    MuFormButtonsComponent,
    MuTableComponent,
    MuTableCaptionDirective,
    MuTableFilterDirective,
    MuTableCellDirective,
    MuTableCellEditorDirective,
    MuModalDialogLayoutComponent,
    MuMultiselectComponent,
    MuTableOptionsComponent,
    MuMapComponent,
    MuSelectButtonComponent,
    MuFormCurrencyComponent,
    MuSectionTitleComponent,
    MuTableNotFoundDirective,
    MuFilterToolbarComponent,
    MuFilterToolbarSidebarComponent,
    MuSidebarComponent,
    MuFilterToolbarFieldDirective,
    MuFilterToolbarFieldLabelDirective,
    MuLoadingModalDialogComponent,
    MuFormPasswordComponent,
    MuFormPasswordCheckerComponent,
    MuFormDropdownComponent,
    MuPopupMenuComponent,
    MuAlertModalDialogComponent,
    MuButtonComponent,
    MuAccordionTemplateDirective,
    MuButtonExtraComponent,
    MuAccordionPreviewTemplateDirective,
    MuRadioIconComponent,
    MuStepsBreadcrumbComponent,
    MuChatComponent,
    MuModalEvidencesComponent,
    MuModalRateComponent,
    MuRatingComponent,
    MuModalScheduleComponent,
    MuModalCancelComponent,
    MuSliderComponent,
    MuRadioCreditCardComponent,
    MuPaymentAddCardComponent,
    MuPaymentAddPseComponent,
    MuAlertComponent,
    MuPaymentsAddWireTransferComponent,
    MuFormAddressComponent,
    MuAutosizeDirective,
    MuFormInputComponent,
    MuFormDropdownCountryComponent,
    MuModalFormSmsComponent,
    MuAutosizeCustomDirective,
    MuFormCodeSmsComponent,
    MuFormTextareaComponent,
    MuNotImagenDirective,
    MuNotImagenCustomDirective,
    MuFormCheckboxRoleComponent,
    MuChipComponent,
    MuMapStaticComponent,
    MuCalendarComponent,
    MuAtlasComponent,
    MuMapLeafletComponent,
  ],
  imports: [
    TranslateModule.forChild({}),
    ReactiveFormsModule,
    FormsModule,
    TableModule,
    ButtonModule,
    CommonModule,
    SharedModule,
    PaginatorModule,
    DialogModule,
    MultiSelectModule,
    TooltipModule,
    RouterModule,
    // GMapModule,
    SelectButtonModule,
    BreadcrumbModule,
    SidebarModule,
    ProgressBarModule,
    ValidatorModule,
    MenuModule,
    DragDropModule,
    RadioButtonModule,
    StepsModule,
    PermissionModule,
    GalleriaModule,
    RatingModule,
    CalendarModule,
    SliderModule,
    InputMaskModule,
    AutoCompleteModule,
    CheckboxModule,
    ChipModule,
  ],
  exports: [
    MuFormFieldsetComponent,
    MuFormSectionComponent,
    MuFormButtonsComponent,
    MuTableComponent,
    MuTableCaptionDirective,
    MuTableFilterDirective,
    MuTableCellDirective,
    MuTableCellEditorDirective,
    MuModalDialogLayoutComponent,
    MuMultiselectComponent,
    MuTableOptionsComponent,
    MuMapComponent,
    MuSelectButtonComponent,
    MuFormCurrencyComponent,
    MuSectionTitleComponent,
    MuTableNotFoundDirective,
    MuFilterToolbarComponent,
    MuFilterToolbarSidebarComponent,
    MuSidebarComponent,
    MuFilterToolbarFieldDirective,
    MuFilterToolbarFieldLabelDirective,
    MuLoadingModalDialogComponent,
    MuFormPasswordComponent,
    MuFormPasswordCheckerComponent,
    MuFormDropdownComponent,
    MuPopupMenuComponent,
    MuAlertModalDialogComponent,
    MuButtonComponent,
    MuAccordionTemplateDirective,
    MuButtonExtraComponent,
    MuAccordionPreviewTemplateDirective,
    MuRadioIconComponent,
    MuStepsBreadcrumbComponent,
    MuChatComponent,
    MuModalEvidencesComponent,
    MuModalRateComponent,
    MuRatingComponent,
    MuModalScheduleComponent,
    MuModalCancelComponent,
    MuSliderComponent,
    MuRadioCreditCardComponent,
    MuPaymentAddCardComponent,
    MuPaymentAddPseComponent,
    MuPaymentsAddWireTransferComponent,
    MuAlertComponent,
    MuFormAddressComponent,
    MuAutosizeDirective,
    MuFormInputComponent,
    MuFormDropdownCountryComponent,
    MuModalFormSmsComponent,
    MuAutosizeCustomDirective,
    MuFormCodeSmsComponent,
    MuFormTextareaComponent,
    MuNotImagenDirective,
    MuNotImagenCustomDirective,
    MuFormCheckboxRoleComponent,
    MuChipComponent,
    MuMapStaticComponent,
    MuCalendarComponent,
    MuAtlasComponent,
  ],
  providers: [MessageService, MuMapMarkerService],
})
export class DesignSystemModule {}
